import React from "react";
import LabelValuePair from "../common/LabelValuePair";
import {
  AuditLog,
  AuditLogTypeLabels,
} from "../../models/AuditLog";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogNarrow } from "@/lib/dialogSize";

const ViewOrganizationAssignedUserChangeAuditLogDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
  organizationId: string;
}> = ({ auditLog, open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={`${dialogNarrow} overflow-hidden`}>
        {auditLog ? (
          <>
            <DialogHeader>
              <DialogTitle>
                {AuditLogTypeLabels[auditLog.eventType]}
              </DialogTitle>
            </DialogHeader>

            <Separator />

            <div className="m-0">
              <div className="flex flex-col gap-2">
                {auditLog.oldValue && (
                  <LabelValuePair
                    label="Previously assigned user"
                    value={auditLog.oldValue}
                  />
                )}
                {auditLog.newValue && (
                  <LabelValuePair
                    label="Newly assigned user"
                    value={auditLog.newValue}
                  />
                )}
              </div>
            </div>

            <Separator />

            <LabelValuePair
              label="Peroformed By"
              value={auditLog.performerEmailAddress}
            />

            <LabelValuePair
              label="Event Date"
              value={auditLog.eventDate}
            />
          </>
        ) : (
          <div />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewOrganizationAssignedUserChangeAuditLogDetailsModal;
